import team from './team'
export default team